import { forwardRef } from 'react';
import MuiAvatar, { type AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';

export type AvatarProps = MuiAvatarProps;

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>((props, ref) => (
  <MuiAvatar ref={ref} {...props} />
));

Avatar.displayName = 'Avatar';
